var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPurging = function SvgPurging(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 83 82"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M64.228 80.998a3.48 3.48 0 0 0 3.068-1.839l3.33-6.23a21.03 21.03 0 0 0 2.191-12.905 20.6 20.6 0 0 0-5.08-10.713c-.517-.573-.653-1.407-.29-2.089l13.857-26.015a6.1 6.1 0 0 0 .453-4.557 5.92 5.92 0 0 0-2.887-3.513 6.1 6.1 0 0 0-4.557-.452 5.92 5.92 0 0 0-3.513 2.887L56.942 41.588c-.362.681-1.13 1.034-1.894.926a20.7 20.7 0 0 0-11.726 1.753c-4.07 1.913-7.409 5.044-9.496 9.01l-13.11 25.178a1.74 1.74 0 0 0 1.542 2.543h10.58a3.74 3.74 0 0 0 3.273-1.93l4.15-7.501-1.36 7.376a1.74 1.74 0 0 0 1.71 2.055h6.14a3.74 3.74 0 0 0 3.273-1.93l4.15-7.501-1.36 7.376a1.74 1.74 0 0 0 1.71 2.055z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeWidth: 3.478,
    d: "m12.435 50.697 3.478-6.956 6.957-3.478-6.957-3.479-3.478-6.956-3.478 6.956L2 40.263l6.957 3.478zM38.522 26.35l4.056-8.118 8.118-4.056-8.118-4.056-4.056-8.118-4.056 8.117-8.118 4.057 8.117 4.056z",
    opacity: 0.4
  })));
};
export default SvgPurging;